import { css } from 'styled-components'

import dmSans300 from './dm-sans-v17-latin/dm-sans-v17-latin-300.woff2'
import dmSans500 from './dm-sans-v17-latin/dm-sans-v17-latin-500.woff2'
import dmSans600 from './dm-sans-v17-latin/dm-sans-v17-latin-600.woff2'
import dmSans700 from './dm-sans-v17-latin/dm-sans-v17-latin-700.woff2'
import dmSans400 from './dm-sans-v17-latin/dm-sans-v17-latin-regular.woff2'

export const fonts = css`
	/* dm-sans-300 - latin */
	@font-face {
		font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
		font-family: 'DM Sans';
		font-style: normal;
		font-weight: 300;
		src: url(${dmSans300}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
	}
	/* dm-sans-regular - latin */
	@font-face {
		font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
		font-family: 'DM Sans';
		font-style: normal;
		font-weight: 400;
		src: url(${dmSans400}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
	}
	/* dm-sans-500 - latin */
	@font-face {
		font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
		font-family: 'DM Sans';
		font-style: normal;
		font-weight: 500;
		src: url(${dmSans500}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
	}
	/* dm-sans-600 - latin */
	@font-face {
		font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
		font-family: 'DM Sans';
		font-style: normal;
		font-weight: 600;
		src: url(${dmSans600}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
	}
	/* dm-sans-700 - latin */
	@font-face {
		font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
		font-family: 'DM Sans';
		font-style: normal;
		font-weight: 700;
		src: url(${dmSans700}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
	}
`
